/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux';
import appReducer from './app';
import brandingReducer from './branding';
import bookingReducer from './booking';
import accountReducer from './account';
import organizationReducer from './organization';

export default combineReducers({
  app: appReducer,
  branding: brandingReducer,
  booking: bookingReducer,
  account: accountReducer,
  organization: organizationReducer,
});
